import { Typography } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { DatePicker } from '@mui/x-date-pickers';
import clsx from 'clsx';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';

export interface DatepickerProps extends Omit<ControllerProps, 'render'> {
  label?: string;
  disabled?: boolean;
  className?: string;
  labelOut: boolean;
  disablePast?: boolean;
}

export const Datepicker = ({
  name,
  label,
  disabled,
  labelOut,
  className,
  disablePast,
  ...props
}: DatepickerProps): JSX.Element => {
  const methods = useFormContext();
  return (
    <FormControlLabel
      labelPlacement="top"
      className="m-0 w-full"
      label={
        <Typography
          className={clsx(
            { 'text-mui-error': methods?.formState.errors[name] },
            'font-bold mb-1 ml-6'
          )}
          alignSelf="start"
        >
          {labelOut ? (
            <>
              {label}{' '}
              {!disabled ? (
                <span className="ml-1 text-mui-error">*</span>
              ) : null}
            </>
          ) : null}
        </Typography>
      }
      control={
        <Controller
          name={name}
          {...props}
          render={({ field, fieldState: { error } }) => (
            <DatePicker
              {...field}
              disablePast={disablePast}
              label={
                !labelOut ? (
                  <>
                    {label}
                    {props.rules?.required && !disabled && (
                      <span className="ml-1 text-mui-error">*</span>
                    )}
                  </>
                ) : null
              }
              disabled={disabled}
              className={clsx('w-full', className)}
              slotProps={{
                textField: {
                  disabled: disabled,
                  helperText: error?.message,
                  size: 'small',
                  error: !!error,
                },
              }}
              format="DD/MM/YYYY"
            />
          )}
        />
      }
    />
  );
};
